export function resolveUrl<TParams>(url: string | ((params: TParams) => string), params?: TParams): string {
  return typeof url === 'function' ? url(params as TParams) : url;
}
